<template>
<div container--fluid>
    <v-layout>
        <InvoiceDetailModule :invoice-id="invoice_id"></InvoiceDetailModule>
    </v-layout>
</div>
</template>

<script>
import InvoiceDetailModule from '@modules/invoice/detail.vue';

export default {
    name: 'invoiceDetail',
    components: {
        InvoiceDetailModule,
    },
    props: {
        'invoice_id': {
            type: [Number, String],
            required: true
        }
    },
    data(){
        return {
            //
        }
    },
};
</script>

<style scoped>

</style>
